import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent, loadAnalytics } from "@/lib/analytics";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (consent === "accepted") {
      loadAnalytics();
    } else if (consent === null) {
      // Small delay so page loads first
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const handleAccept = () => {
    setConsent("accepted");
    loadAnalytics();
    dismiss();
  };

  const handleDecline = () => {
    setConsent("declined");
    dismiss();
  };

  const dismiss = () => {
    setLeaving(true);
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[200] px-4 pb-4 ${leaving ? "animate-[slideDown_0.4s_ease-in_forwards]" : "animate-[slideUp_0.5s_ease-out]"}`}
    >
      <div className="max-w-4xl mx-auto backdrop-blur-[12px] bg-[var(--color-surface)]/90 border border-[var(--color-border)] px-5 py-4 flex flex-col md:flex-row md:items-center gap-4">
        <p className="text-xs font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)] flex-1">
          We use cookies to understand how you use our site and improve your experience.
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={handleAccept}
            className="px-4 py-1.5 text-xs font-[family-name:var(--font-mono)] font-medium bg-[var(--color-fg)] text-[var(--color-bg)] rounded-full hover:opacity-90 transition-opacity cursor-pointer"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="px-4 py-1.5 text-xs font-[family-name:var(--font-mono)] border border-[var(--color-border)] text-[var(--color-fg-secondary)] rounded-full hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors cursor-pointer"
          >
            Decline
          </button>
          <Link
            to="/legal#cookies"
            className="text-[10px] font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)] hover:text-[var(--color-fg)] transition-colors whitespace-nowrap"
          >
            Cookie Policy →
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @keyframes slideDown {
          from { transform: translateY(0); opacity: 1; }
          to { transform: translateY(100%); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
